var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('file-upload',{attrs:{"type":"single"},model:{value:(_vm.single),callback:function ($$v) {_vm.single=$$v},expression:"single"}})}
var staticRenderFns = []

export { render, staticRenderFns }